import { render, staticRenderFns } from "./DBTool.vue?vue&type=template&id=4cc2b85c&scoped=true&"
import script from "./DBTool.vue?vue&type=script&lang=js&"
export * from "./DBTool.vue?vue&type=script&lang=js&"
import style0 from "./DBTool.vue?vue&type=style&index=0&id=4cc2b85c&prod&lang=less&scoped=true&"
import style1 from "./DBTool.vue?vue&type=style&index=1&id=4cc2b85c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc2b85c",
  null
  
)

export default component.exports